export enum CustomFieldType {
  TEXT = 'TEXT',
  INTEGER = 'INTEGER',
  MULTI_TEXT = 'MULTI_TEXT',
  DATE = 'DATE',
  TIME = 'TIME',
  BOOLEAN = 'BOOLEAN',
  SELECT = 'SELECT',
  RADIO = 'RADIO',
  DECIMAL = 'DECIMAL',
  ARRAY = 'ARRAY',
  FILE_UPLOAD = 'FILE_UPLOAD',
  CALCULATED = 'CALCULATED',
  DATE_OFFSET = 'DATE_OFFSET',
  TAGS = 'TAGS',
  /** A checkbox group bound to one field key; its value is an array of the ticked options' stored values. */
  MULTI_SELECT = 'MULTI_SELECT',
  /** A dynamic list (up to 10) of {month, year, amount} past-due-rent rows; its amounts can sum into the case total. */
  RENT_HISTORY = 'RENT_HISTORY'
}
